import React from 'react';
import styled from 'styled-components';
import SecondaryRaisedButton from '../buttons/SecondaryRaisedButton';

import CartWrapper from '../styles/AddToCartWrapper';
import { media } from '../styles/breakpoints';
import PriceDisplay from './PriceDisplayWithHeading';

const CartForm = ({ amount, heading, buttonLabel, foxyLabel, foxyCode }) => {
    const InnerCartWrapper = styled.div`
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        flex-wrap: wrap;
        align-items: flex-end;
        margin: 0 auto;
        
        & .schnoffe-button {
          max-width: 10em;
          margin: 0 0 0.15em 0;
        }
    `;

    return (
        <form
            action='https://checkout.stoff.love/cart'
            method='post'
            acceptCharset='utf-8'
        >
            <CartWrapper>
                <InnerCartWrapper>
                    <div>
                        {heading}
                        <PriceDisplay
                            amount={amount}
                            shippingIncluded
                        />
                    </div>
                    <SecondaryRaisedButton
                        type='submit'
                        value='add-to-cart'
                        disabled={false}
                        icon='shopping_cart'
                        text={buttonLabel}
                        className='schnoffe-button'
                    />
                </InnerCartWrapper>
                <div>
                    <input
                        type='hidden'
                        name='name'
                        value={foxyLabel}
                        key={'foxy1'}
                    />
                    <input
                        type='hidden'
                        name='price'
                        value={parseFloat(amount) / 1.19}
                        key={'foxy2'}
                    />
                    <input
                        type='hidden'
                        name='category'
                        value='swatches'
                        key={'foxy3'}
                    />
                    <input
                        type='hidden'
                        name='code'
                        value={foxyCode}
                        key={'foxy4'}
                    />
                </div>
            </CartWrapper>
        </form>
    );
};

export default CartForm;



// WEBPACK FOOTER //
// ./src/components/cartforms/CartForm.js